import { useEffect, useRef, useState } from "react";

/**
 * Intersection-observer reveal — matches the .rv / .rv.in behaviour in
 * the source HTML. Respects prefers-reduced-motion.
 */
export const Reveal = ({ children, as: Tag = "div", className = "", style, ...rest }) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const prefersReduce =
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduce) {
      setSeen(true);
      return;
    }
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setSeen(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, []);

  return (
    <Tag ref={ref} className={`rv${seen ? " in" : ""} ${className}`.trim()} style={style} {...rest}>
      {children}
    </Tag>
  );
};
